import communityHttpClient from './httpClient';
import COMMUNITY_ENDPOINTS from './endpoints';

const BASE_URL = COMMUNITY_ENDPOINTS.CERTIFICATES;

export const getData = () =>
  communityHttpClient.get(`${BASE_URL}/data/`);

export const verify = (certificateId) =>
  communityHttpClient.get(`${BASE_URL}/verify/${certificateId}/`);

export default {
  getData,
  verify
};
